import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { Subscription } from 'rxjs';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { Sets } from '../../shared/utilities/shared.functions';

@Component({
  selector: 'custom-grid-filters',
  templateUrl: './custom-grid-filters.component.html',
  styleUrls: ['./custom-grid-filters.component.css']
})
export class CustomGridFiltersComponent implements OnInit, OnChanges, OnDestroy {
  @Input() filters: any; // type to be declared later
  @Output() filtersChange = new EventEmitter();
  @Input() area: 'activities' | 'cases' | 'documents' | 'rating' | 'customers' | 'campaigns' | 'assets' | 'service' | 'properties' | 'outbox' | 'kanban'; // used for switches load, save filters;
  @Input() grid: AgGridAngular;
  @Input() update;
  @Output() updateChange = new EventEmitter<boolean>();
  sub: Subscription;
  allFilters:GridCustomFilterObject[]; // type to be declared later
  active:string | null;
  inputFilterNotSaved:boolean = false;
  noFilter:boolean = false;
  showFilters:boolean = false;

  constructor(private sharedData: SharedDataService) { }

  ngOnInit(): void {
    this.loadCustomFilters();
  }

  ngOnChanges(changes: SimpleChanges): void {
    //if(!!changes.area && !!changes.area.currentValue) console.log('Grid area:', this.area);
    if(!!changes.filters && !!changes.filters.currentValue) this.gridFilterChanged();
    if(!!changes.update && !!changes.update.currentValue) this.gridFilterChanged();
    if(!!changes.grid && !!changes.grid.currentValue) this.initGrid();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  loadCustomFilters(){
    this.sub = this.sharedData.filterUpdate().subscribe(
      {
        next:(data)=>{
          switch(this.area){
            case 'activities': {
              this.extractAndUpdate(data.activities);
              break
            }
            case 'cases': {
              this.extractAndUpdate(data.caseOverView);
              break
            }
            case 'documents': {
              this.extractAndUpdate(data.offerOverView);
              break
            }
            case 'rating' :{
              this.extractAndUpdate(data.ratingOverview);
              break
            }
            case 'customers': {
              this.extractAndUpdate(data.customerOverView);
              break
            }
            case 'campaigns': {
              this.extractAndUpdate(data.campaigns);
              break
            }
            case 'assets': {
              this.extractAndUpdate(data.assets);
              break
            }
            case 'service':{
              this.extractAndUpdate(data.service);
              break
            }
            case 'properties':{
              this.extractAndUpdate(data.propertiesOverview);
              break
            }
            case 'outbox':{
              this.extractAndUpdate(data.outboxOverview);
            }
            case 'kanban':{
              this.extractAndUpdate(data.kanbanFilters);
              break
            }
            
          }
        },
        error:(err)=> console.error(this.area, ' failed to load filters', err),
        complete:()=>{}
      }
    )
  }

  extractAndUpdate(data:any){
    if(!!data && !data.version) {
      this.allFilters = !!data.savedFilters ? data.savedFilters as GridCustomFilterObject[] : [];
      if(!!this.filters) this.checkIfCurrentFilterIsSaved();
      else this.filters = data;
    }
    else this.allFilters = [];
  }

  activateFilter(f){
    this.active = f.name;
    this.grid.api.setFilterModel(f.filter);
  }

  deleteFilter(i){
    this.allFilters.splice(i,1);
    // this.filters.savedFilters.splice(i,1);
    this.saveFilters();
  }

  async addFilter(){
    let i = document.getElementById('customFilterCreationInput') as HTMLInputElement;
    if(!this.filters.savedFilters) this.filters.savedFilters = [];
    this.filters.savedFilters.push({
      name: i.value,
      filter: this.grid.api.getFilterModel()
    });
    this.saveFilters();
  }

  checkIfCurrentFilterIsSaved(): void {
    if (!this.grid || !this.grid.api) {
      //console.warn('Grid or grid API not available.');
      return;
    }

    const currentFilter = this.grid.api.getFilterModel();
    let filterFound = false;
    for (const savedFilter of this.allFilters) {
      if (this.areFiltersEqual(currentFilter, savedFilter.filter)) {
        this.active = savedFilter.name;
        this.inputFilterNotSaved = false;
        this.noFilter = false;
        filterFound = true;
        break;
      }
    }

    if (!filterFound) {
      this.inputFilterNotSaved = true;
      this.active = null;
      this.noFilter = Object.keys(currentFilter).length === 0;
    }
  }

  private areFiltersEqual(filter1: Object, filter2: Object): boolean {
    if (typeof filter1 !== 'object' || typeof filter2 !== 'object') {
      return filter1 === filter2;
    }
  
    if (filter1 === null || filter2 === null) {
      return filter1 === filter2;
    }
  
    const keys1 = Object.keys(filter1);
    const keys2 = Object.keys(filter2);
  
    if (keys1.length !== keys2.length) {
      return false;
    }
  
    for (const key of keys1) {
      if (!keys2.includes(key)) {
        return false;
      }
      if (!this.areFiltersEqual(filter1[key], filter2[key])) {
        return false;
      }
    }
  
    return true;
  }
  
  gridFilterChanged(){
    this.updateChange.emit(false);
    if(!!this.allFilters && !!this.allFilters.length ){
      this.checkIfCurrentFilterIsSaved();
    }
    if(!!this.grid){
      let m = this.grid.api.getFilterModel();
      if(!Object.keys(m).length) this.noFilter = true;
      else this.noFilter = false;
      this.inputFilterNotSaved = true;
    }
  }

  compareFilters(a,b, type){
    switch(type){
      case 'set': {
        return !!(Sets.difference(a.values, b.values).length == 0)
      }
      case 'contains': 
      case 'text': {
        return a.type == b.type && a.filter.toLowerCase() == b.filter.toLowerCase();
      }
      case 'date': {
        return a.dateFrom == b.dateFrom && a.dateTo == b.dateTo && a.type == b.type;
      }
    }
  }

  isFiltered(){
    if(!!this.filters && Object.keys(this.filters).length != 0) return true
    return false;
  }

  saveFilters(){
    switch(this.area){
      case 'cases':{
        this.sharedData.caseOverViewFilters = this.filters;
        break
      }
      case 'customers': {
        this.sharedData.customerOverviewFilters = this.filters;
        break
      }
      case 'activities':{
        this.sharedData.activitiesFilter = this.filters;
        break
      }
      case 'rating':{
        console.log(this.filters)
        this.sharedData.ratingsOverviewFilters = this.filters;
        break
      }
      case 'documents':{
        this.sharedData.offerOverViewFilters = this.filters;
        break
      }
      case 'campaigns':{
        this.sharedData.campaginFilters = this.filters;
        break
      }
      case 'assets':{
        this.sharedData.assetFilters = this.filters;
        break
      }
      case 'service':{
        this.sharedData.serviceFilters = this.filters;
        break
      }
      case 'properties':{
        this.sharedData.propertiesOverviewFilters = this.filters;
        break
      }
      case 'outbox': {
        this.sharedData.outboxFilters = this.filters;
        break
      }
      case 'kanban': {
        this.sharedData.kanbanFilters = this.filters;
        break
      }
    }
  }

  filterName(index, filter){
    return filter.name
  }

  /**
   * Grid has been added and listener is added.
   * When the event firstDataRendered is registered, other events should be ready for action.
   */
  initGrid(){
    // this.grid.api.addGlobalListener(this.gridListener)
  }

  gridListener(test,event){
    switch(event){
      case 'displayedColumnsChanged': {break}
      case 'dragStopped': {break}
      case 'filterChanged': {
        break
      }
      case 'sortChanged' : {}
      case 'paginationChanged' : {
        // used in cases for pagination load
        // emit reload ?
      }
      case 'firstDataRendered': {
        // When first data is rendered, check current column state for comparison when 
      }
    }
    // console.log(event)
  }
}

/**
 * CustomFilters
 * -------------
 * 
 * Load custom filter based on area (page visited).
 * 
 * Check if those filters should be updated to a new version
 * 
 * Those filters will be put into allFilters for:
 *    compare current filter with saved filters (highlight if in use)
 *    options to save filter if current filter does not exist in allFilters
 *    For creating hover over text explaining what the filter does.
 * 
 * Clicking on a filter (activating a filter) will put them directly into the grid (supplied by input)
 * 
 * removing a filter will save the updated filters
 */

/**
 * Filter object
 * name is the displayed name of the filter, can not be duplicate
 * filter is an object, with colDefId keys and their respective filter setting.
 */
class GridCustomFilterObject {
  name: string;
  filter: Object;
}